// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2hjkz","button":"styles__button___3Aeyl"};